import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { ToolItem } from '../../ExtractionType/Hierarchy/Steps/Tools/types';
import { useGetErgonomicToolList } from '@/hooks/useGetErgonomicToolList';
import { useGetErgonomicToolsByReport } from '@/hooks/useGetErgonomicToolsByReport';
import { TOOL_CONFIGS } from '../../ExtractionType/Hierarchy/Steps/Tools/Form/Icons';

export interface ToolWithCount extends ToolItem {
	count: number;
}

interface ToolCount {
	[key: string]: number;
}

export function useHandleTools(): ToolWithCount[] {
	const { dataExtractionReport } = useDataExtractionReport();
	const EXCLUDED_TOOLS = new Set(['rula']);

	const { data: toolList = [] } = useGetErgonomicToolList({
		organization_id: dataExtractionReport?.organization_id || '',
		company_id: dataExtractionReport?.company_id || ''
	});

	const { data: toolsCount } = useGetErgonomicToolsByReport({
		organization_id: dataExtractionReport?.organization_id || '',
		company_id: dataExtractionReport?.company_id || '',
		custom_report_id: dataExtractionReport?.custom_report_id || null,
		start_date: dataExtractionReport?.start_date || '',
		end_date: dataExtractionReport?.end_date || ''
	});

	if (!toolList?.length) {
		return [];
	}

	const toolCountData = toolsCount as ToolCount | undefined;

	return toolList
		.filter((tool) => !EXCLUDED_TOOLS.has(tool.key))
		.map((tool) => {
			const toolKey = String(tool.key);
			const config = TOOL_CONFIGS[toolKey];
			const count = toolCountData?.[`total_${toolKey}`] || 0;

			return {
				ergonomic_tool_id: String(tool.value),
				ergonomic_tool_name: toolKey,
				formatted_name: String(tool.label),
				icon: config?.createIcon() || null,
				count
			};
		});
}
